// extracted by mini-css-extract-plugin
export default {"main":"styles_main__m7Mvm","container2":"styles_container2__MYAWL","events":"styles_events__mZHlP","event_container":"styles_event_container__4gS5b"};